export const MOBILE_VIEW = 'screen and (max-width: 768px)';
export const TABLET_VIEW = 'screen and (min-width: 769px) and (max-width: 1024px)';
export const MONITOR_VIEW = 'screen and (min-width: 1024px)';